module.exports = __webpack_public_path__ + "img/detail-logo.8458b214.svg";